import { create } from 'zustand';

const useCustomPayStore = create(() => ({
    isCustomPay: window && window.location && window.location.hostname && window.location.hostname.includes('payview')
}));

export default useCustomPayStore;